import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

class AccordionCustom extends HTMLElement {
  get details() {
    const details = this.querySelector('details');

    if (!(details instanceof HTMLDetailsElement)) {
      throw new Error('Details element not found');
    }

    return details;
  }

  get summary() {
    const summary = this.details.querySelector('summary');

    if (!(summary instanceof HTMLElement)) {
      throw new Error('Summary element not found');
    }

    return summary;
  }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#setDefaultOpenState();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });

    this.details.addEventListener('toggle', this.#handleToggle, {
      signal,
    });

    mediaQueryLarge.addEventListener(
      'change',
      this.#handleMediaQueryChange,
      { signal }
    );
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();

    this.details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
  }

  #handleToggle = () => {
    if (!this.details.open) return;

    const accordion = this.closest('.accordion');

    if (!accordion) return;

    accordion
      .querySelectorAll('accordion-custom details')
      .forEach((detail) => {
        if (detail !== this.details) {
          detail.open = false;
        }
      });
  };

  #handleKeyDown = (event) => {
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();

      this.details.open = false;
      this.summary.focus();
    }
  };
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}